/**
 * Eén regel plus een i-icoon met de volledige uitleg (JP, punt 11 van
 * 22-09).
 *
 * De definitie van "Mediaan eerste reactie" stond voluit in de tegel en
 * duwde het cijfer naar beneden; bij vier tegels naast elkaar was de
 * rij daardoor hoger dan het cijfer zelf. De uitleg moet er blijven —
 * een mediaan zonder definitie is een getal waar je niets mee kunt —
 * maar niet als lap tekst.
 *
 * Wat je ziet: de eerste regel van de uitleg, afgekapt op één regel,
 * met een i-knop erachter. De knop draagt de hele tekst als `title`
 * (de tooltip van de browser, ook bij toetsenbordfocus) en klapt hem
 * bij een klik uit voor wie geen muis gebruikt of op een telefoon zit —
 * daar bestaat hover niet.
 */
import { useEffect, useRef, useState } from "react";

export function UitlegTip({
  tekst,
  /** Korte regel vóór het icoon; leeg laten toont alleen het icoon. */
  kort,
  label = "Wat betekent dit cijfer?",
}: {
  tekst: string;
  kort?: string;
  label?: string;
}) {
  const [open, setOpen] = useState(false);
  const blok = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!open) return;
    function buiten(gebeurtenis: MouseEvent) {
      if (!blok.current?.contains(gebeurtenis.target as Node)) setOpen(false);
    }
    function ontsnap(gebeurtenis: KeyboardEvent) {
      if (gebeurtenis.key === "Escape") setOpen(false);
    }
    document.addEventListener("mousedown", buiten);
    document.addEventListener("keydown", ontsnap);
    return () => {
      document.removeEventListener("mousedown", buiten);
      document.removeEventListener("keydown", ontsnap);
    };
  }, [open]);

  return (
    <span className="wp-gz-uitlegtip" ref={blok}>
      {kort ? <span className="wp-gz-uitlegregel">{kort}</span> : null}
      <button
        type="button"
        className="wp-gz-i"
        aria-label={label}
        aria-expanded={open}
        title={tekst}
        onClick={() => setOpen((v) => !v)}
      >
        i
      </button>
      {open ? (
        <span className="wp-gz-uitlegpop" role="note">
          {tekst}
        </span>
      ) : null}
    </span>
  );
}
